import React, { Component } from 'react';
import * as Water from './Saga/Water';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
// import * as Customers from '../../Store/Customers';
// import * as Responses from '../../Store/Responses';
// import * as Monies from '../../Store/Monies';
// import DateFnsUtils from '@date-io/date-fns';
// import "react-datepicker/dist/react-datepicker.css";
// import ja from "date-fns/locale/ja";
import {Field} from 'redux-form';
import { Select, MenuItem } from '@material-ui/core';
// import '../../Css/Table.css';

// import DatePicker from "react-datepicker";

// const {MuiPickersUtilsProvider,KeyboardDatePicker} = require('@material-ui/pickers');
interface Props {

    // handleSubmit:any,
    // onSubmit:any,
    // get_rent_contract_accounting:any,
    // output:any,
    // name:string,
    // date1:string,
    // date2:string,
    // update_kyousai_comp:any
}


interface State {
 
  }
   //対象月
   const targetMonth = [
    {value:"1", label:"奇数月"},
    {value:"2", label:"偶数月"},
    {value:"3", label:""},
    {value:"4", label:""},
    {value:"5", label:""},
  ];
  //検針日
  const readingDate = [
    {value:"1", label:"1日"},
    {value:"2", label:"末尾"},
    {value:"3", label:""},
    {value:"4", label:""},
    {value:"5", label:""},
  ];

class WaterSetting extends Component<Props, State> {

  constructor(props: Readonly<Props>) {
                super(props);
 

    this.state = {
      targetMonth: "",
    }
  }

//   constructor(props) {
//     super(props);
// console.log(props);

 
    componentWillMount() {

        // this.props.initialize({output:true,name:"",date1:"",date2:""});//フォームに初期値を反映させる


    }
    onChange(e:any) {
      console.log(e.target.value);
      this.setState({ reservationsPeople: e.target.value });
    }

    render() {

        // const { handleSubmit } = this.props;
       
     
      return (
          <div style={{marginLeft:20}}>
              {/* <form onSubmit={handleSubmit}  > */}
              <div style={{fontSize:18, textAlign:"left"}}>水道検針物件設定</div>
                  <button
                      type="submit"
                      style={{margin:"5px"}}
                      className="btn btn-primary float-right"
                     
                  >対象物件追加</button>
              {/* </form> */}
      </div>
    );
  }
} 




const mapStateToProps = (state:any) => {
    return {

        // responseid: state.customersReducer.responseid,
        // responsedetail: state.customersReducer.responsedetail,
        // customerNewDisp: state.customersReducer.customerNewDisp,
        // customerdetail0: state.customersReducer.customerdetail0
      
    }
}
function mapDispatchToProps(dispatch:any) {
    return {

        // responseUpdate(state) {
        //     dispatch(Responses.responseUpdate(state))
        // },
 
        update_kyousai_comp(state:any) {
            // dispatch(Water.update_kyousai_comp(state))
        },
        
    };
}

// export default connect(mapStateToProps, mapDispatchToProps)(KyousaiSearch);
export default connect(mapStateToProps, mapDispatchToProps)(WaterSetting);

// AccountingListSearchComponent = connect(
//     mapStateToProps, mapDispatchToProps
// )(AccountingListSearchComponent);
// export default  reduxForm<Props>({
//     form: 'formset',

// })(AccountingListSearchComponent);
// const form = reduxForm({
//     form: 'formset', // a unique identifier for this form
    
//     //enableReinitialize: true, // initialValuesプロップが更新されると、フォームも更新されます。
// })(KyousaiSearch)

// export default Form;

